namespace SPA
{
	export namespace Realtor2
	{
		export namespace New
		{
			export class ObjectDetails extends Guide.GuideContent
			{

				private m_Form: ui.Form.Form;

				public constructor( private m_Data: IObjectDetails, private m_Obj: Realtor2.NewObject )
				{
					super();

					this.m_Form = new ui.Form.Form(
						{
							action: '',
							method: 'POST',
							notSwitchable: true,
							submit: () => { return; }
						}
					);
				}

				public build( root: ui.base.BaseHTMLElement ): void
				{
					root.css( 'padding-top', '20px' );

					const row1: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement('div')
						.addClass('row')
						.appendTo(root);

					this.buildBarkeiten(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo( row1 )
					);

					const row2: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( root );

					this.buildData(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-lg-6' )
						.appendTo( row2 )
					);

					this.buildParkingSegments(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-lg-6' )
						.appendTo( row2 )
					);
				}

				protected buildNavigation( nav: ui.base.BaseHTMLElement ): void
				{
					new ui.base.Button(
						$('<i class="fas fa-arrow-circle-left"></i> <span>Zurück</span>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel ) { this.m_Panel.MovePrev(); }
								}
							}
						}
					).rebuild( nav );

					new ui.base.Button(
						$('<span>Weiter</span> <i class="fas fa-arrow-circle-right"></i>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel )
									{
										if ( this.m_Obj.checkForm( this.m_Form ) )
										{
											this.m_Panel.MoveNext();
										}
									}
								}
							}
						}
					).rebuild( nav );
				}

				private buildBarkeiten( _root: ui.base.BaseHTMLElement ): void
				{
					_root.empty();

					const row: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( _root );

					const usability: ui.Form.RadioGroup = new ui.Form.RadioGroup(
						{
							value: this.m_Data.object.usability,
							name: 'details.object.usability',
							radioButtons:
							[
								{
									value: 'VERY_GOOD',
									title: 'Sehr gut'
								},
								{
									value: 'GOOD',
									title: 'Gut'
								},
								{
									value: 'SATISFYING',
									title: 'Befriedigend'
								},
								{
									value: 'SUFFICIENT',
									title: 'Ausreichend'
								},
								{
									value: 'INADEQUAT',
									title: 'Mangelhaft'
								}
							],
							inline: 5,
							required: true,
							on:
							{
								change: () =>
								{
									// @ts-ignore
									this.m_Data.object.usability = usability.val() || 'SATISFYING';
								}
							}
						}
					);

					const lettability: ui.Form.RadioGroup = new ui.Form.RadioGroup(
						{
							value: this.m_Data.object.lettability,
							name: 'details.object.lettability',
							radioButtons:
							[
								{
									value: 'VERY_GOOD',
									title: 'Sehr gut'
								},
								{
									value: 'GOOD',
									title: 'Gut'
								},
								{
									value: 'SATISFYING',
									title: 'Befriedigend'
								},
								{
									value: 'SUFFICIENT',
									title: 'Ausreichend'
								},
								{
									value: 'INADEQUAT',
									title: 'Mangelhaft'
								}
							],
							inline: 5,
							required: true,
							on:
							{
								change: () =>
								{
									// @ts-ignore
									this.m_Data.object.lettability = lettability.val() || 'SATISFYING';
								}
							}
						}
					);

					const ability_ann: ui.Form.TextArea = new ui.Form.TextArea(
						{
							text: this.m_Data.object.annotation,
							on:
							{
								change: () =>
								{
									this.m_Data.object.annotation = (ability_ann.val() || '').trim();
								}
							},
							css:
							{
								resize: 'vertical'
							},
							rows: 5,
							control: true
						}
					);

					const usage_self: ui.Form.Select = new ui.Form.Select(
						{
							option:
							{
								YES: 'Ja',
								NO: 'Nein'
							},
							control: true,
							required: true,
							on:
							{
								change: () =>
								{
									this.m_Data.object.use_capability = usage_self.val() !== 'NO';
								}
							}
						},
						this.m_Data.object.use_capability ? 'YES' : 'NO'
					);

					const left: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'col-xs-12' )
					.appendTo( row );

					const right: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'col-xs-12' )
					.appendTo( row );

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Verwertbarkeit' )
									.addClass( 'control-label col-xs-12 col-md-3' )
								)
							.appendTo( left )
						),
						this.m_Form,
						usability
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Vermietbarkeit' )
									.addClass( 'control-label col-xs-12 col-md-3' )
								)
							.appendTo( left )
						),
						this.m_Form,
						lettability
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-sm-6 col-md-4 col-lg-2' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Ist das Objekt eigennutzungsfähig?' )
									.addClass( 'control-label col-xs-12 col-md-4 col-md-offset-1' )
								)
							.appendTo( left )
						),
						this.m_Form,
						usage_self
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Bemerkungen zur Verwertbarkeit / Vermietbarkeit' )
									.addClass( 'control-label col-xs-12' )
								)
							.appendTo( right )
						),
						this.m_Form,
						ability_ann
					);
				}

				private buildData( _root: ui.base.BaseHTMLElement ): void
				{
					_root.empty();

					const c_y: ui.Form.TextInput = new ui.Form.TextInput(
						this.m_Data.object.construction_year ? this.m_Data.object.construction_year.toString() : '',
						{
							required: true,
							control: true,
							classes: ['iwv-req'],
							on:
								{
									change: () => {
										this.m_Data.object.construction_year = parseInt(c_y.val() || '', 10);
									}
								}
						});

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-sm-7 col-md-6 col-lg-8' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Baujahr' )
									.addClass( 'control-label col-xs-12 col-sm-5 col-md-6 col-lg-4' )
								)
							.appendTo( _root )
						),
						this.m_Form,
						c_y
					);

					const flg: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-sm-7 col-md-6 col-lg-8' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Flächenangabe' )
									.addClass( 'control-label col-xs-12 col-sm-5 col-md-6 col-lg-4' )
								)
							.appendTo( _root )
						)
					);

					const _t: ui.Form.Select = new ui.Form.Select(
						{
							control: false,
							required: false,
							on:
							{
								change: () =>
								{
									// @ts-ignore
									this.m_Data.living_area.type = _t.val();
								}
							},
							option:
							{
								NGF: 'Wohnfläche',
								BGF: 'Bruttogrundfläche'
							}
						},
						this.m_Data.living_area.type
					);

					const fl: ui.Form.TextInput = new ui.Form.TextInput(
						this.m_Data.living_area.value ? accounting.formatNumber(this.m_Data.living_area.value) : '',
						{
							classes: ['number iwv-req'],
							control: true,
							required: true,
							on:
							{
								change: () =>
								{
									this.m_Data.living_area.value = accounting.unformat(fl.val() || '0');
								}
							}
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'span' )
							.addClass( 'input-group-addon' )
						.appendTo( flg ),
						this.m_Form,
						_t
					);
					this.addToForm( flg, this.m_Form, fl );
					new ui.base.BaseHTMLElement( 'span' )
						.addClass( 'input-group-addon' )
						.text( 'm²' )
					.appendTo( flg );
				}

				private buildOrderSegment(_root: ui.base.BaseHTMLElement): void
				{
					_root.empty();

					const orderWfb = new ui.Form.Checkbox({value: "1", title: 'Wohnflächenberechnung bestellen', descriptor: {name: 'order.wfb'}});
					const orderBgfb = new ui.Form.Checkbox({value: "1", title: 'Bruttogrundflächenberechnung bestellen', descriptor: {name: 'order.bgfb'}});
					const orderLayout = new ui.Form.Checkbox({value: "1", title: 'Grundriss bestellen', descriptor: {name: 'order.plan'}});

					orderWfb.rebuild(_root);
					orderBgfb.rebuild(_root);
					orderLayout.rebuild(_root);
				}

				private buildParkingSegments( _root: ui.base.BaseHTMLElement ): void
				{
					_root.empty();

					const _pbox: ui.Box.Box = new ui.Box.Box( true );
					_pbox.addTitle( 'Parkplatzsegmente' );
					_pbox.rebuild( _root );

					new ui.base.Button(
						$('<i class="fas fa-plus-circle"></i> <span>Neues Parkplatzsegment hinzufügen</span>'),
						{
							classes: [ 'btn-sm' ],
							context: "default",
							attr: {
								style: "display: block; margin-bottom:10px;"
							},
							on:
							{
								click: () =>
								{
									this.m_Data.parking.push(
										{
											construction_year: this.m_Data.object.construction_year,
											factory_costs: 10000.0, // ? Könnte ein EInstellungsfeld pro Makler sein
											type: 'GARAGE'
										}
									);

									this.buildParkingSegments( _root );
								}
							}
						}
					).rebuild( _pbox );

					const pbox: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'container-fluid' )
					.appendTo( _pbox );

					this.m_Data.parking.forEach(
						( seg, index, list ) =>
						{
							const row: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'row' )
							.appendTo( pbox );

							const _t: ui.Form.Select = new ui.Form.Select(
								{
									option:
									{
										GARAGE: 'Garage',
										PARKING: 'Stellplatz',
										CARPORT: 'Carport',
										UNDERGROUND: 'Tiefgarage'
									},
									on:
									{
										change: () =>
										{
											// @ts-ignore
											seg.type = _t.val();
										}
									}
								},
								seg.type
							);

							this.addToForm(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'col-xs-9' )
								.appendTo(
									new ui.base.BaseHTMLElement( 'div')
										.addClass('form-group clearfix' )
										.append(
											new ui.base.BaseHTMLElement( 'label' )
												.text( 'Typ' )
											.addClass( 'control-label col-xs-3' )
										)
									.appendTo(
										new ui.base.BaseHTMLElement( 'div' )
											.addClass( 'col-xs-6 col-md-6' )
										.appendTo( row )
									)
								),
								this.m_Form,
								_t
							);

							const _cy: ui.Form.NumberInput = new ui.Form.NumberInput(
								seg.construction_year,
								{
									on:
									{
										change: () =>
										{
											// @ts-ignore
											seg.construction_year = _cy.val();
										}
									}
								}
							);

							this.addToForm(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'col-xs-8' )
								.appendTo(
									new ui.base.BaseHTMLElement( 'div')
										.addClass('form-group clearfix' )
										.append(
											new ui.base.BaseHTMLElement( 'label' )
												.text( 'Baujahr' )
											.addClass( 'control-label col-xs-4' )
										)
									.appendTo(
										new ui.base.BaseHTMLElement( 'div' )
											.addClass( 'col-xs-6 col-md-6' )
										.appendTo( row )
									)
								),
								this.m_Form,
								_cy
							);

							const _fc: ui.Form.NumberInput = new ui.Form.NumberInput(
								seg.factory_costs,
								{
									on:
									{
										change: () =>
										{
											// @ts-ignore
											seg.factory_costs = _fc.val();
										}
									}
								}
							);

							this.addToForm(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'col-xs-7' )
								.appendTo(
									new ui.base.BaseHTMLElement( 'div')
										.addClass('form-group clearfix' )
										.append(
											new ui.base.BaseHTMLElement( 'label' )
												.text( 'Baukosten' )
											.addClass( 'control-label col-xs-5' )
										)
									.appendTo(
										new ui.base.BaseHTMLElement( 'div' )
											.addClass( 'col-xs-6' )
										.appendTo( row )
									)
								),
								this.m_Form,
								_fc
							);

							new ui.base.Button(
								$('<i class="fas fa-trash"></i> <span>Entfernen</span>'),
								{
									context: 'danger',
									classes: [ 'pull-right', 'btn-sm' ],
									on:
									{
										click: () =>
										{
											this.m_Data.parking = this.m_Data.parking.filter(
												( e, i ) =>
												{
													return i !== index;
												}
											);

											row.remove();
										}
									}
								}
							)
							.rebuild(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'col-xs-6' )
								.appendTo( row )
							);

							if ( index + 1 < list.length )
							{
								row.css( 'border-bottom', '1px solid #ddd' );
							}

							if ( index !== 0 )
							{
								row.css( 'padding-top', '10px' );
							}
						}
					);
				}
			}
		}
	}
}
